import { getRelativeTime } from 'src/compass/shared/util/casMoment';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

export function CasRenderRelativeDateTime(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);
  return !!value && getRelativeTime(value);
}
